import React from 'react';
import classnames from 'classnames';
import s from './OutlinedDASymbol.scss';
let lastId = 0;
var _React_Component;
class OutlinedDASymbol extends (_React_Component = React.Component) {
    render() {
        const props = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], s[props.palette], props.className)
        }, /*#__PURE__*/ React.createElement("svg", {
            viewBox: "0 0 276.4 446.6"
        }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
            id: `outlined-da-symbol-gradient-${this.svgId}`,
            gradientTransform: "rotate(128)",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ React.createElement("stop", {
            className: s['stop1'],
            offset: "0%",
            stopColor: s[`${props.palette}-color1`]
        }), /*#__PURE__*/ React.createElement("stop", {
            className: s['stop2'],
            offset: "100%",
            stopColor: s[`${props.palette}-color2`]
        }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
            fill: `url(#outlined-da-symbol-gradient-${this.svgId})`,
            d: "M273.9,2.5v78.1l-81.6,155.9l-0.8,1.5l1,1.3l6.7,8.2l0.8,0.9h1.2h72.7v106.5H139.7h-0.8l-0.6,0.4l-12,8.1l-0.5,0.4l-0.3,0.6L87.3,437l-7.1,7.2H2.5V366l81.6-155.9l0.8-1.5l-1.1-1.3l-6.7-8.1l-0.7-0.9h-1.2H2.5V91.8h134.3h0.8l0.6-0.4l12-8.1l0.5-0.4l0.3-0.6l38.1-72.7l7.1-7.2H273.9 M276.4,0L276.4,0h-81.2l-8.1,8.2l-38.3,73l-12,8.1H0v111.5h75.2l6.7,8.1L0,365.4v81.2h0h81.2l8.1-8.2l38.3-73l12-8.1h136.8V245.8h-75.2l-6.7-8.2l81.9-156.4V0L276.4,0z"
        }))));
    }
    constructor(...args){
        super(...args);
        this.svgId = ++lastId;
    }
}
OutlinedDASymbol.defaultProps = {
    palette: 'green'
};
export default OutlinedDASymbol;
